import React, { useState, useEffect, useRef } from "react";
import { Trans, useTranslation } from "react-i18next";
import {
  useLocation,
  usePrompt,
  useNavigate
} from "react-router-dom";
import Geocode from "react-geocode";
import { Button, Label, TextError, TitleH1, TitleH4 } from "components/generic";
import Select from "components/Select";
import { ContainerValue, ContainerView } from "components/containers";
import { MenuLeftSide } from "components/MenuLeftSide";
import { useRadiobox } from "components/CheckRadiobox";
import {
  DateNone,
  IHouse,
  StrNum,
  THouseType,
  TMode,
} from "interfaces/intarfaces";
import { RoomsDetails } from "./RoomsDetails";
import { DivButtons, DivGrid, MainWrapper, maxWidthContainer } from "./styles";
import { InputLabel, useInput } from "components/Input";
import { useSelect } from "components/Select";
import { AboutTheRoom } from "./AboutTheRoom";
import { useTextArea } from "components/TextArea";
import { HOST_ROOMADD_ROUTE, HOST_ROOMS_ROUTE } from "utils/constants";
import { AvailabilityPrice } from "./AvailabilityPrice";
import { useCalendar } from "components/Calendar";
import { theme } from "styles/theme";
import { getLanguage, sortTop } from "utils/fetchMapInfo";
import MultiSelect, { useMultiSelect, ISelectMulti } from "components/MultiSelect";
import Modal from "components/Modal";
import { useContextHost } from "context/ContextHost";
import { UnauthorizedUser } from "pages/ProfileUser/SimpleComponents";
import { isValue } from "utils/logics";
import { DialogPublish } from "./DialogPublish";
import { IError, isDateInPeriod, isEmptyItem, isoDate } from "utils/helpers";
import { LoaderCustom } from "components/Loader";
import { useContextHospi } from "context/ContextHospi";
import { TLang } from "assets/data/isoNameLanguage";

export type KeyHouse = keyof IHouse;

type TAnchorCreateHouse =
  | "titleAboutRoom"
  | "roomsDetailsAnchor"
  | "dateInAv"
  | "picturesRoom"
  | null;

let data_form: Partial<
  Record<keyof IHouse, string | number | string[] | boolean | null>
> = {};

Geocode.setApiKey(process.env.REACT_APP_GOOGLE_API as string);
Geocode.setLanguage("gb");
Geocode.setRegion("nl");

export const HostHouseRegistration: React.FC = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation("hostrooms");
  const { userProfile } = useContextHospi();
  // Errors block
  const [responseError, setResponseError] = useState("");
  const [response401, setResponse401] = useState(false);
  const [errorAnchor, setErrorAnchor] = useState<TAnchorCreateHouse>(null);
  const [isPhotosEmpty, setIsPhotosEmpty] = useState<any>(false)
  const [isAnyDateOut, setIsAnyDateOut] = useState<boolean>(false)
  // get cotext Data
  const {
    currentHouse,
    currentPhotos,
    loading,
    getDataHouse,
    republishRoom,
    createRoom,
    updateRoom,
    uploadImages,
    publishRoom,
    reorderImages,
    setCurrentPhotos
  } = useContextHost();
  const [loaderText, setLoaderText] = useState("");
  // Definition mode page
  const { pathname } = useLocation();
  const [mode, setMode] = useState<TMode>('create')
  const [reorderList, setReorderList] = useState<{ file_name: string, order: number }[]>([])
  const [showModal, setShowModal] = useState<string>("");
  const [requiredField, setRequiredField] = useState(false);
  const [orderedNewImages, setOrderedNewImages] = useState<{ uid: string, name: string, order: number }[]>([])
  const [fileTypeError, setFileTypeError] = useState<string>('')

  useEffect(() => {
    setMode(pathname === `/${i18n.language}${HOST_ROOMADD_ROUTE.slice(5)}` ? "create" : "edit")
  }, [i18n.language, pathname])

  useEffect(() => {
    setIsAnyDateOut(currentHouse.available_to === '2101-01-01')
  }, [currentHouse.available_to])

  const loadersTexts = {
    loadingRoom: t("textLoading.0"),
    savingData: t("textLoading.1"),
    savingImages: t("textLoading.2"),
  };

  // Add field for Update houses data if it changed
  const solvingPut = (
    e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
    keyP: KeyHouse
  ) => {
    if (e.target !== undefined && e.target.value !== currentHouse[keyP]) {
      if (isValue(e.target.value)) {
        data_form[keyP] = e.target.value;
      } else if (isValue(currentHouse[keyP] as StrNum)) {
        data_form[keyP] = null;
      }
    } else delete data_form[keyP];
  };

  function checkFileType() {
    const box = document.getElementById('picturesRoom')
    const test = box?.querySelector('.anticon-picture')
    if (test) {
      const p = test.parentElement
      const t = p!.parentElement
      t!.style.border = '1px solid red'
    }
    return box?.querySelector('.anticon-picture') !== null
  }

  const onblur = (nameInput: KeyHouse) => {
    return {
      onBlur: (e: React.FocusEvent<HTMLInputElement>) =>
        solvingPut(e, nameInput),
    };
  };

  useEffect(() => {
    if (mode === "edit") {
      let houseID = pathname.slice(3).split("/")[2];
      if (houseID && !!houseID.length) getDataHouse(houseID);
    }
    // eslint-disable-next-line
  }, [mode]);

  // Initial state FORM
  // Rooms details
  const typeRoom = useRadiobox("typeRooms", "");
  const titleRoom = {
    ...useInput(""),
    ...onblur("title"),
    required: requiredField,
  };
  const country = { ...useSelect("NL"), required: requiredField };
  const province = { ...useSelect(""), required: requiredField };
  const postalCode = {
    ...useInput(""),
    ...onblur("postal_code"),
    required: requiredField,
  };
  const houseNumber = {
    ...useInput(""),
    ...onblur("house_number"),
    required: requiredField,
  };
  const addition = { ...useInput(""), ...onblur("additional_house_number") };
  const street = {
    ...useInput(""),
    ...onblur("street"),
    required: requiredField,
  };
  const city = {
    ...useInput(""),
    ...onblur("city"),
    required: requiredField,
  };
  // const city = { ...useSelect(), required: requiredField };

  // About the Rooms
  const bedroomSize = {
    ...useInput(""),
    ...onblur("bedroom_area"),
    required: requiredField,
  };
  const houseSize = {
    ...useInput(""),
    ...onblur("house_area"),
    required: requiredField,
  };
  const [sharedUse, setSharedUse] = useState<string[]>([]);
  const [privateUse, setPrivateUse] = useState<string[]>([]);
  const descriptionAboutRoom = {
    ...useTextArea(""),
    onBlur: (e: React.FocusEvent<HTMLTextAreaElement>) =>
      solvingPut(e, "description"),
  };
  // eslint-disable-next-line
  const [filePictureList, setFilePictureList] = useState<File[]>([]);

  // eslint-disable-next-line
  const [filesForDelete, setFilesForDelete] = useState<string[]>([]);
  // Availability & prices
  const dateIn = {
    ...useCalendar({
      value: undefined,
    }),
    required: requiredField,
  };
  const dateOut = {
    ...useCalendar({
      value: undefined,
    }),
    required: requiredField,
  };

  const roomPrice = {
    ...useInput("", 6),
    ...onblur("price"),
    required: requiredField,
  };
  const deposit = {
    ...useInput("", 6),
    ...onblur("deposit"),
    required: requiredField,
  };
  const additionalCosts = {
    ...useInput("", 6),
    ...onblur("additional_expenses"),
    required: requiredField,
  };
  // Preferred tenant profile
  const minimumAge = { ...useInput("", 2), ...onblur("min_tennant_age") };
  const maximumAge = { ...useInput("", 2), ...onblur("max_tennant_age") };
  const preferredGender = useSelect();
  const preferredLanguage = useMultiSelect(
    getLanguage(i18n.language.toUpperCase() as TLang),
    [],
    ["gb", "nl"]
  );

  const propsMultiSelect: ISelectMulti = {
    ...preferredLanguage,
    items: sortTop(getLanguage(i18n.language.toUpperCase() as TLang), [
      "gb",
      "nl",
    ]).filter((item) => !preferredLanguage.values?.includes(item.value as string)),
    selected: getLanguage(i18n.language.toUpperCase() as TLang).filter((item) =>
      preferredLanguage.values?.includes(item.value as string)
    ),
  };

  useEffect(() => {
    if (mode === "edit") {
      setLoaderText(!!!currentHouse.house_id ? loadersTexts.loadingRoom : "");
    }
    // eslint-disable-next-line
  }, [currentHouse, mode]);

  const getDates = (line: string | undefined): [DateNone, DateNone] => {
    if (line === undefined || !!!line.length) return [undefined, undefined];
    return [new Date(line), new Date(line)];
  };

  const isRePublish = () =>
    mode === "edit" && currentHouse.house_status === "RENTED";

  // Load current state
  useEffect(() => {
    // Rooms details
    typeRoom.valueChange(currentHouse.kind ?? "");
    titleRoom.onChange(currentHouse.title);
    province.changeItem(currentHouse.province);
    postalCode.onChange(currentHouse.postal_code);
    houseNumber.onChange(currentHouse.house_number);
    addition.onChange(currentHouse.additional_house_number);
    street.onChange(currentHouse.street);
    city.onChange(currentHouse.city);
    // city.changeItem(currentHouse.city);
    // About the Rooms
    bedroomSize.onChange(currentHouse.bedroom_area ?? "");
    houseSize.onChange(currentHouse.house_area ?? "");
    setSharedUse(currentHouse.shared_items);
    setPrivateUse(currentHouse.private_items);
    descriptionAboutRoom.onChange(currentHouse.description);
    // Availability & prices
    dateIn.onChange(
      ...getDates(isRePublish() ? undefined : currentHouse.available_from)
    );
    dateOut.onChange(
      ...getDates(isRePublish() ? undefined : currentHouse.available_to)
    );
    roomPrice.onChange(isRePublish() ? "" : currentHouse.price ?? "");
    deposit.onChange(isRePublish() ? "" : currentHouse.deposit ?? "");
    additionalCosts.onChange(
      isRePublish() ? "" : currentHouse.additional_expenses ?? ""
    );
    // Preferred tenant profile
    minimumAge.onChange(
      currentHouse.min_tennant_age === 0 ? "" : currentHouse.min_tennant_age
    );
    maximumAge.onChange(
      currentHouse.max_tennant_age === 0 || currentHouse.max_tennant_age === 99
        ? ""
        : currentHouse.max_tennant_age
    );
    preferredGender.changeItem(currentHouse.gender);

    getLanguage(i18n.language.toUpperCase() as TLang).map((item) =>
      preferredLanguage.changeSelected(
        item.value,
        currentHouse.spoken_languages.includes(item.value as string)
      )
    );
    // eslint-disable-next-line
  }, [currentHouse]);


  // Check required fileds
  useEffect(() => {
    const checkFillRequiedFields = () => {
      const patternPostalCode = new RegExp("[0-9]{4}[A-Za-z]{2}");
      if (
        [
          typeRoom.selected.length,
          String(titleRoom.value).trim(),
          String(country.value).trim(),
          String(houseNumber.value).trim(),
          String(street.value).trim(),
          String(city.value).trim(),
          province.value
        ].some(isEmptyItem) ||
        !patternPostalCode.test(String(postalCode.value))
      ) {
        setErrorAnchor("roomsDetailsAnchor");
      } else if (
        [bedroomSize.value, houseSize.value, sharedUse.length].some(isEmptyItem)
      ) {
        setErrorAnchor("titleAboutRoom");
      } else if (
        [
          dateIn.value,
          dateOut.value,
          String(roomPrice.value).length,
          String(additionalCosts.value).length,
          String(deposit.value).length,
        ].some(isEmptyItem)
      ) {
        setErrorAnchor("dateInAv");
      }
      else if (
        !!_checkRentedPeriod(dateIn.value, dateOut.value).length
      ) {
        setErrorAnchor("dateInAv");
      }
      else setErrorAnchor(null);
    };
    checkFillRequiedFields();
  });

  const _checkRentedPeriod = (start: DateNone, finish: DateNone) => {
    let errorLine = "";

    // for (let { check_in_date, check_out_date } of currentHouse.rent_dates!) {
    //   console.log(check_in_date, check_out_date)
    //   if (isDateInPeriod(isoDate(start), check_in_date, check_out_date))
    //     errorLine = t("rooms.errorPeriod", { date: isoDate(start) }) + "\n";
    //   if (isDateInPeriod(isoDate(finish), check_in_date, check_out_date)) {
    //     errorLine += t("rooms.errorPeriod", { date: isoDate(finish) });
    //   }
    //   if (!!errorLine.length) return errorLine;
    // }
    for (let { check_in_date, check_out_date } of currentHouse.rent_dates!) {
      if (isoDate(start) < check_in_date && isoDate(finish) > check_out_date)
        return t("rooms.errorPeriod", {
          date: [isoDate(start), isoDate(finish)].join(", "),
        });
    }
    return errorLine;
  };

  const showError = (res: IError) => {
    if (res.status === 401) setResponse401(true);
    else
      try {
        setResponseError(
          (res as IError).errorMessages
            .map((line: [string, string]) => `${line[0]} - ${line[1]}`)
            .join("\n")
        );
      } catch (error) {
        setResponseError("Error");
      }
  };

  const sendFromData = async () => {
    let errorLine = _checkRentedPeriod(dateIn.value, dateOut.value);
    const error = checkFileType()
    if (error) {
      setFileTypeError(t('fileTypeError'))
      let el = document.getElementById('picturesRoom');
      setTimeout(() => {
        el?.scrollIntoView({ behavior: "smooth" });
      }, 500);
      return
    } else {
      setFileTypeError('')
    }

    if (errorAnchor !== null) {
      let el = document.getElementById(errorAnchor);
      setRequiredField(true);
      setTimeout(() => {
        el?.scrollIntoView({ behavior: "smooth" });
      }, 500);
      if (!!errorLine.length) {
        setResponseError(errorLine);
        return
      }
      return;
    }

    setIsPhotosEmpty(false)
    setResponseError("");
    setLoaderText(loadersTexts.savingData);
    // Send republish request
    if (isRePublish()) {
      // Send republish request
      await republishRoom({
        available_from: isoDate(dateIn.value),
        available_to: isoDate(dateOut.value),
        price: roomPrice.value as number,
        additional_expenses: additionalCosts.value as number,
        deposit: deposit.value as number,
      });
      setLoaderText("");
      navigate(`/${i18n.language}${HOST_ROOMS_ROUTE.slice(5)}`)
      // history.push(`/${i18n.language}${HOST_ROOMS_ROUTE.slice(5)}`);
      return;
    }
    const newpostalcode = String(postalCode.value).replace(/[^\d.-]/g, '')
    const locations = await Geocode.fromAddress(
      `${country.value},${province.value},${city.value},${newpostalcode}`
    );
    const { lat: latitudeHouse, lng: longitudeHouse } =
      locations.results[0].geometry.location;
    // Send new house data
    if (mode === "create") {
      // ADD new House
      const houseFormData: IHouse = {
        kind: typeRoom.selected as THouseType,
        title: titleRoom.value as string,
        country: country.value as string,
        province: province.value as string,
        postal_code: postalCode.value as string,
        house_number: houseNumber.value as string,
        additional_house_number: addition.value as string,
        street: street.value as string,
        city: city.value as string,
        latitude: latitudeHouse,
        longitude: longitudeHouse,
        bedroom_area: bedroomSize.value as number,
        house_area: houseSize.value as number,
        shared_items: sharedUse,
        private_items: privateUse,
        description: descriptionAboutRoom.value as string,
        available_from: isoDate(dateIn.value),
        available_to: isAnyDateOut ? '2101-01-01' : isoDate(dateOut.value),
        price: roomPrice.value as number,
        additional_expenses: additionalCosts.value as number,
        deposit: deposit.value as number,
        min_tennant_age: (minimumAge.value as number) || 0,
        max_tennant_age: (maximumAge.value as number) || 99,
        gender:
          (preferredGender.value as string).length === 0
            ? "any"
            : (preferredGender.value as string),
        spoken_languages: preferredLanguage.values?.length
          ? preferredLanguage.values
          : ["ANY"],
      };
      const res = await createRoom(houseFormData);
      if (res.status === 200) {
        const houseID = (res as { status: number; data: string }).data;
        if (reorderList.length) {
          await reorderImages(houseID, reorderList)
        }
        await uploadImages(houseID, filePictureList);
        setShowModal(houseID);
      } else showError(res as IError);
      setLoaderText("");
    }
    // Send update data house
    else if (mode === "edit" && !isRePublish()) {
      // EDIT existing house
      // Check changed in complex fields
      if (typeRoom.selected !== currentHouse.kind)
        data_form["kind"] = typeRoom.selected;
      if (country.value !== currentHouse.country)
        data_form["country"] = country.value;
      if (province.value !== currentHouse.province)
        data_form["province"] = province.value;
      if (city.value !== currentHouse.city) data_form["city"] = city.value;
      if (sharedUse.sort().join() !== currentHouse.shared_items.sort().join())
        data_form["shared_items"] = sharedUse;
      if (privateUse.sort().join() !== currentHouse.private_items.sort().join())
        data_form["private_items"] = privateUse;
      if (isoDate(dateIn.value) !== currentHouse.available_from)
        data_form["available_from"] = isoDate(dateIn.value);
      if (isoDate(dateOut.value) !== currentHouse.available_to || (isAnyDateOut && isoDate(dateOut.value) !== '2101-01-01'))
        data_form["available_to"] = isAnyDateOut ? '2101-01-01' : isoDate(dateOut.value);
      if (preferredGender.value !== currentHouse.gender)
        data_form["gender"] = preferredGender.value;
      // if (province.value !== currentPhotos)
      //   data_form["province"] = province.value;
      if (
        preferredLanguage.values.sort().join() !==
        currentHouse.spoken_languages.sort().join()
      )
        data_form["spoken_languages"] = preferredLanguage.values?.length
          ? preferredLanguage.values
          : ["ANY"];
      if (Object.keys(data_form).includes("min_tennant_age"))
        data_form = {
          ...data_form,
          min_tennant_age: (minimumAge.value as number) || 0,
        };
      if (Object.keys(data_form).includes("max_tennant_age"))
        data_form = {
          ...data_form,
          max_tennant_age: (maximumAge.value as number) || 99,
        };
      const isChangeAddress =
        Object.keys(data_form).filter((item) =>
          [
            "country",
            "province",
            "city",
            "house_number",
            "additional_house_number",
            "street",
            "postal_code",
          ].includes(item)
        ).length > 0;
      if (isChangeAddress) {
        data_form["latitude"] = latitudeHouse;
        data_form["longitude"] = longitudeHouse;
      }
      const houseID = pathname.slice(2).split("/")[2];
      if (Object.keys(data_form).length) {
        delete data_form.user_id;
        let res = await updateRoom(data_form as Partial<IHouse>, houseID);
        if (res.status !== 200) {
          showError(res as IError);
          return;
        }
      }
      if (reorderList.length) {
        await reorderImages(houseID, reorderList)
      }
      await uploadImages(houseID, filePictureList, filesForDelete, orderedNewImages);
      setLoaderText("");
    }
    data_form = {};
    setCurrentPhotos([])
    setFilesForDelete([])
    navigate(`/${i18n.language}${HOST_ROOMS_ROUTE.slice(5)}`)
    // history.push(`/${i18n.language}${HOST_ROOMS_ROUTE.slice(5)}`);
  };

  const requestPublish = async (isSend: boolean) => {
    isSend && publishRoom(showModal);
    setShowModal("");
    navigate(`/${i18n.language}${HOST_ROOMS_ROUTE.slice(5)}`)
    // history.push(`/${i18n.language}${HOST_ROOMS_ROUTE.slice(5)}`);
  };

  const dateLine = (value: string | undefined): string => {
    if (!value) return "";
    const dt = new Date(value);
    return `${("0" + dt.getDate()).slice(-2)}-${(
      "0" +
      (dt.getMonth() + 1)
    ).slice(-2)}-${dt.getFullYear()}`;
  };

  usePrompt(t(`notFilledInYet`), (isPhotosEmpty || errorAnchor || filesForDelete.length));

  // When user Unauthorized
  if (response401) return <UnauthorizedUser />;


  return (

    <ContainerView>
      <MenuLeftSide routeActive={`/${i18n.language}${HOST_ROOMS_ROUTE.slice(5)}`} />
      <MainWrapper style={{ paddingBottom: "4em" }}>
        <TitleH1 maxWidth={maxWidthContainer}>{t("titleCreate")}</TitleH1>
        {loading && (
          <LoaderCustom
            size={5}
            color={theme.colors.bgBody}
            text={loaderText}
          />
        )}
        <ContainerValue maxWidth={maxWidthContainer}>
          <RoomsDetails
            modeView={
              mode === "edit"
                ? currentHouse.house_status === "RENTED"
                  ? "re-publish"
                  : "edit"
                : mode
            }
            typeRoom={typeRoom}
            titleRoom={{ ...titleRoom }}
            country={country}
            province={{ ...province, required: requiredField }}
            postalCode={postalCode}
            houseNumber={houseNumber}
            addition={addition}
            street={street}
            city={city}
          />
          <AboutTheRoom
            setFileTypeError={setFileTypeError}
            fileTypeError={fileTypeError}
            modeView={
              mode === "edit"
                ? currentHouse.house_status === "RENTED"
                  ? "re-publish"
                  : "edit"
                : mode
            }
            setOrderedNewImages={setOrderedNewImages}
            setReorderList={setReorderList}
            bedroomSize={bedroomSize}
            houseSize={houseSize}
            listSharedUse={sharedUse}
            listPrivateUse={privateUse}
            setListSharedUse={setSharedUse}
            setListPrivateUse={setPrivateUse}
            descriptionAboutRoom={descriptionAboutRoom}
            currentPhotos={mode === "create" ? [] : currentPhotos as any}
            filePictureList={filePictureList}
            setFilePictureList={setFilePictureList}
            setFilesForDelete={setFilesForDelete}
            required={requiredField}
            setIsPhotosEmpty={setIsPhotosEmpty}
          />
        </ContainerValue>
        <TitleH1 maxWidth={maxWidthContainer}>
          {t("availabilityPrices.title")}
        </TitleH1>
        <ContainerValue maxWidth={maxWidthContainer}>
          {currentHouse.rent_dates?.map((item, j) => (
            <Trans
              t={t}
              i18nKey={`rooms.rented`}
              values={{
                date_from: dateLine(item.check_in_date),
                date_to: dateLine(item.check_out_date),
              }}
              parent={TitleH4}
              style={{ color: theme.colors.primary }}
              key={j}
            />
          ))}
          <AvailabilityPrice
            modeView={
              mode === "edit"
                ? currentHouse.house_status === "RENTED"
                  ? "re-publish"
                  : "edit"
                : mode
            }
            rentalError={responseError}
            isAnyDateOut={isAnyDateOut}
            setIsAnyDateOut={setIsAnyDateOut}
            dateIn={dateIn}
            dateOut={dateOut}
            roomPrice={roomPrice}
            deposit={deposit}
            additionalCosts={additionalCosts}
          />
        </ContainerValue>
        <TitleH1 maxWidth={maxWidthContainer}>
          {t("preferredTenat.title")}
        </TitleH1>
        <ContainerValue maxWidth={maxWidthContainer}>
          <Label fontColor={theme.colors.thirdly} p="0 0 24px 0">
            {t("preferredTenat.info")}
          </Label>
          <TitleH4 >
            {t("preferredTenat.infosub")}
          </TitleH4>
          <DivGrid>
            <InputLabel
              {...minimumAge}
              type="number"
              title={t("preferredTenat.item.minimumAge.title")}
              placeholder={t("preferredTenat.item.minimumAge.placeholder")}
              id="minimumAge"
              maxLength={3}
              min={0}
              max={100}
              onFocus={() => {
                // eslint-disable-next-line
                if (minimumAge.value == 0) minimumAge.onChange("");
              }}
              disabled={
                mode === "edit" && currentHouse.house_status === "RENTED"
              }
            />
            <InputLabel
              {...maximumAge}
              type="number"
              title={t("preferredTenat.item.maximumAge.title")}
              placeholder={t("preferredTenat.item.maximumAge.placeholder")}
              id="maximumAge"
              maxLength={3}
              min={0}
              max={100}
              onFocus={() => {
                // eslint-disable-next-line
                if (maximumAge.value == 0) maximumAge.onChange("");
              }}
              disabled={
                mode === "edit" && currentHouse.house_status === "RENTED"
              }
            />
            <Select
              {...preferredGender}
              items={[
                { value: "male", label: `${t("preferredTenat.item.gender.male")}` },
                { value: "female", label: `${t("preferredTenat.item.gender.female")}` },
                { value: "any", label: `${t("preferredTenat.item.gender.any")}` },
              ]}
              title={t("preferredTenat.item.preferredGender.title")}
              placeholder={t("preferredTenat.item.preferredGender.placeholder")}
              id="preferredGender"
              disabled={
                mode === "edit" && currentHouse.house_status === "RENTED"
              }
            />
            <MultiSelect
              {...propsMultiSelect}
              title={t("preferredTenat.item.preferredLanguage.title")}
              placeholder={t(
                "preferredTenat.item.preferredLanguage.placeholder"
              )}
              id="preferredLanguage"
              disabled={
                mode === "edit" && currentHouse.house_status === "RENTED"
              }
            />
          </DivGrid>
        </ContainerValue>
        {(!(responseError.includes('rental period') || responseError.includes('inclusief huurperiode')) && responseError.length > 0) && (
          <ContainerValue maxWidth={maxWidthContainer}>
            <TextError>{responseError}</TextError>{" "}
          </ContainerValue>
        )}
        <DivButtons style={{ paddingBottom: "5em" }}>
          <Button
            normal
            onClick={() => navigate(`/${i18n.language}${HOST_ROOMS_ROUTE.slice(5)}`)}
            m="0 24px 0 0"
          >
            {t(`buttonCancel`)}
          </Button>
          <Button main onClick={() => sendFromData()}>
            {t(`buttonSave`)}
          </Button>
        </DivButtons>
      </MainWrapper>
      {!!showModal.length && (
        <Modal isShow={!!showModal.length} handleClose={() => setShowModal("")}>
          <DialogPublish
            requestPublish={requestPublish}
            isVerified={userProfile?.verification_status! === "verified"}
            isProfileCompleted={userProfile?.is_profile_complete ?? false}
          />
        </Modal>
      )}
    </ContainerView>
  );
};
